import { Component, Input } from '@angular/core';
import { FileExtractionEventLogGet, FileExtractionGet } from '../../../../core/interfaces/admin-interfaces';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-expanded-extraction-history',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './expanded-extraction-history.component.html',
  styleUrl: './expanded-extraction-history.component.css'
})
export class ExpandedExtractionHistoryComponent {
  @Input() historyItem: FileExtractionGet | null = null;
  @Input() loadedEventLogs?: FileExtractionEventLogGet[];
  

  // Toast
  @Input() toast!: ToastComponent;

  formatJson(value: any): string {
    return JSON.stringify(value, null, 2);
  }

  copyToClipboard(data: any): void {
    const formatted = this.formatJson(data);
    navigator.clipboard.writeText(formatted).then(
      () => {
        this.toast.showToast('shared.success', 'admin.code_copied', 'success', 2000, true);
      },
      (err) => {
      }
    );
  }
}
